(function ($) {
    $.dhnPopup = {
        // --------------------------------------------------------------------
        // OPEN FUNCTION
        // --------------------------------------------------------------------
        open: function (options) {
            const defaults = {
                popupId: null,
                backdropId: null,
                position: "center", // e.g. 'center', 'bottom-right', etc.
                animation: null, // e.g. 'slide-in-bottom', 'zoom-in'
                hasBackdrop: true,
                delay: 0, // delay in ms before showing
                showOnce: "none", // 'none' | 'session' | 'day'
                localStorageKey: null, // used for local/sessionStorage tracking
                skipIfDontShowAgain: true,
                scrollTrigger: 0, // if > 0, show popup after scrolling this many px
                elementTrigger: null, // NEW: selector for an element to trigger on
            };
            const settings = $.extend({}, defaults, options);

            // Basic checks
            if (!settings.popupId) return;
            const $popup = $(settings.popupId);
            if (!$popup.length) return;

            // Determine localStorage key
            const lsKey =
                settings.localStorageKey || settings.popupId + "-popupShown";

            // ------------------------------------------------------------------
            // 1) Check "Don't show me again" logic
            // ------------------------------------------------------------------
            if (settings.skipIfDontShowAgain) {
                const dontShowAgainKey = lsKey + "-dontShowAgain";
                const dsaValue = localStorage.getItem(dontShowAgainKey);
                if (dsaValue === "true") {
                    // user has checked "don't show me again"
                    return;
                }
            }

            // ------------------------------------------------------------------
            // 2) Check showOnce logic: 'session' or 'day'
            // ------------------------------------------------------------------
            if (settings.showOnce === "session") {
                // If shown once in current session, skip
                if (sessionStorage.getItem(lsKey) === "true") return;
            } else if (settings.showOnce === "day") {
                // If shown once today, skip
                const lastShown = localStorage.getItem(lsKey);
                if (lastShown) {
                    const today = new Date().toDateString();
                    if (lastShown === today) return;
                }
            }

            // ------------------------------------------------------------------
            // 3) The function that actually displays the popup
            // ------------------------------------------------------------------
            const doShowPopup = function () {
                // Remove any conflicting classes
                $popup.removeClass(
                    "center bottom-left bottom-right top-left top-right " +
                    "slide-in-bottom slide-in-left zoom-in fade-in slide-bottom " +
                    "drawer-right drawer-left active"
                );
                // Add desired position class
                $popup.addClass(settings.position);

                // If there's an animation class, add it
                if (settings.animation) {
                    $popup.addClass(settings.animation);
                }

                // Activate the popup
                $popup.addClass("active");

                // Show backdrop if needed
                if (settings.hasBackdrop && settings.backdropId) {
                    const $backdrop = $(settings.backdropId);
                    $backdrop.addClass("active");
                }

                // Mark as shown in session/localStorage if needed
                if (settings.showOnce === "session") {
                    sessionStorage.setItem(lsKey, "true");
                } else if (settings.showOnce === "day") {
                    localStorage.setItem(lsKey, new Date().toDateString());
                }
            };

            // ------------------------------------------------------------------
            // 4) Decide: immediate/delayed, scroll-based, or element-based
            // ------------------------------------------------------------------

            // (A) If elementTrigger is set, show when that element enters the viewport
            if (settings.elementTrigger) {
                const $targetEl = $(settings.elementTrigger);
                if (!$targetEl.length) {
                    // If the selector is invalid, just fallback to normal immediate/delayed
                    if (settings.delay && settings.delay > 0) {
                        setTimeout(doShowPopup, settings.delay);
                    } else {
                        doShowPopup();
                    }
                    return;
                }

                let triggeredPopup = false;
                const onScrollCheck = function () {
                    const scrollTop = $(window).scrollTop();
                    const windowHeight = $(window).height();
                    const elementOffsetTop = $targetEl.offset().top;

                    // If the element's top is within or above the visible viewport bottom:
                    if (!triggeredPopup && scrollTop + windowHeight >= elementOffsetTop) {
                        triggeredPopup = true;
                        $(window).off("scroll", onScrollCheck);

                        if (settings.delay && settings.delay > 0) {
                            setTimeout(doShowPopup, settings.delay);
                        } else {
                            doShowPopup();
                        }
                    }
                };

                $(window).on("scroll", onScrollCheck);

                // (B) Else if scrollTrigger > 0, show after user scrolls X px
            } else if (settings.scrollTrigger && settings.scrollTrigger > 0) {
                let triggeredPopup = false;

                const onScrollCheck = function () {
                    const scrollTop = $(window).scrollTop();
                    if (!triggeredPopup && scrollTop >= settings.scrollTrigger) {
                        triggeredPopup = true;
                        $(window).off("scroll", onScrollCheck);

                        if (settings.delay && settings.delay > 0) {
                            setTimeout(doShowPopup, settings.delay);
                        } else {
                            doShowPopup();
                        }
                    }
                };

                $(window).on("scroll", onScrollCheck);

                // (C) Otherwise, show immediately or with a delay
            } else {
                if (settings.delay && settings.delay > 0) {
                    setTimeout(doShowPopup, settings.delay);
                } else {
                    doShowPopup();
                }
            }
        },

        // --------------------------------------------------------------------
        // CLOSE FUNCTION
        // --------------------------------------------------------------------
        close: function (options) {
            const defaults = {
                popupId: null,
                backdropId: null,
                setDontShowAgain: false,
                localStorageKey: null,
                onClose: null, // Add this callback option
            };
            const settings = $.extend({}, defaults, options);

            if (!settings.popupId) return;
            const $popup = $(settings.popupId);
            if (!$popup.length) return;

            $popup.removeClass("active");

            if (settings.backdropId) {
                $(settings.backdropId).removeClass("active");
            }

            if (settings.setDontShowAgain && settings.localStorageKey) {
                const dontShowAgainKey = settings.localStorageKey + "-dontShowAgain";
                localStorage.setItem(dontShowAgainKey, "true");
            }

            // Execute callback if provided
            if (settings.onClose && typeof settings.onClose === 'function') {
                settings.onClose();
            }
        },
    };

    // ----------------------------------------------------------------------
    // GLOBAL EVENT HANDLERS
    // ----------------------------------------------------------------------

    // 1) Close button click
    $(document).on("click", ".dhn-close-btn", function () {
        const $popup = $(this).closest(".dhn-popup");
        const popupId = "#" + $popup.attr("id");
        const backdropId = popupId + "-backdrop";

        // Check if there's a "Don't show again" checkbox
        const $dontShow = $popup.find("#dont-show-again");
        const isDontShowChecked = $dontShow.is(":checked");

        const lsKey = popupId + "-popupShown";
        $.dhnPopup.close({
            popupId: popupId,
            backdropId: backdropId,
            setDontShowAgain: isDontShowChecked,
            localStorageKey: lsKey,
        });
    });

    // 2) Backdrop click -> close popup (only if hasBackdrop is true)
    $(document).on("click", ".dhn-popup-backdrop.active", function (e) {
        // Only close if user clicks directly on the backdrop itself (not a child)
        if (e.target !== this) return;

        const backdropId = "#" + $(this).attr("id");
        const popupId = backdropId.replace("-backdrop", "");
        const $popup = $(popupId);
        if (!$popup.length) return;

        const $dontShow = $popup.find("#dont-show-again");
        const isDontShowChecked = $dontShow.is(":checked");

        const lsKey = popupId + "-popupShown";
        $.dhnPopup.close({
            popupId: popupId,
            backdropId: backdropId,
            setDontShowAgain: isDontShowChecked,
            localStorageKey: lsKey,
        });
    });
})(jQuery);
